<template>
  <div>
    <b-row style="margin-top: 4em">
      <b-col cols="12" sm="12" md="2">
        <ulu-logo :brand="service.brand" />
      </b-col>
      <b-col>
        <h2 class="text-secondary">
          <i>{{
            $t("globals.service_service").toUpperCase() +
              " " +
              this.$route.params.id
          }}</i>
        </h2>
        <h6 class="text-secondary">
          <router-link
            style="color:#17a2b8"
            :to="{ name: 'customer', params: { id: parseInt(this.service.customer.id) } }"
          >
            {{ service.customer.company_name + ', ' }}
          </router-link>
          <router-link
            style="color:#17a2b8"
            :to="{ name: 'order', params: { id: parseInt(this.service.order.id) } }"
          >
            {{ $t("globals.order") + ': ' + service.order.order_no }}
          </router-link>
        </h6>
      </b-col>
      <b-col>
        <b-btn
          v-if="service.status == 'created'"
          class="m-1 float-right"
          variant="danger"
          size="sm"
          @click="deleteService"
        >
          {{ $t("globals.delete") }}
        </b-btn>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";

export default {
  components: {
    "ulu-logo": () => import("@/components/common/Logo.vue")
  },
  props: {
    refresh: Function,
    service: {
      type: Object,
      default: () => ({
        brand: "cartracker",
        customer: {
          id: 0,
          company_name: ""
        },
        order: {
          id:0,
          order_no:0
        }
      })
    }
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"]),
    ...mapMutations(["setShowLoadingModal"]),
    deleteService() {
      const confirm_text = "Are you sure you want to delete this service? (This action can NOT be reversed)";

      let data = {
        query: `mutation { res: ServiceDelete (service_id: ${parseInt(
          this.$route.params.id
        )} ) }`
      };

      this.simpleMutation({ data, this_ref: this, confirm_text }).then(() => {
        this.$router.push({ name: "allservices" });
      });
    }
  }
};
</script>

<style scoped>
.logo {
  height: 2em;
}
</style>
